import React from "react";
import routerProvider from "@pankod/refine-react-router-v6";
import { TitleProps } from "@pankod/refine-core";
import { Typography } from "@pankod/refine-antd";
import styles from "./styles.module.css";

const { Link } = routerProvider;
const { Title: RefineTitle } = Typography;

export const Title: React.FC<TitleProps> = ({ collapsed }) => (
  <Link to="/">
    <RefineTitle level={3} className={styles.title}>
      {collapsed ? "CC" : "Crooklyn Clan"}
    </RefineTitle>
  </Link>
);
